import React from 'react';
import AdminRoutes from "./AdminRoutes";

function AdminApp() {
    return (
      <>
          <AdminRoutes />
      </>
    );
}

export default AdminApp;
